import * as React from 'react';

import styled from '@emotion/styled';
import { L } from '../../../../../lib/i18n';
import { Supplier } from '@app/api/models/AccountSettings';
import { Checkbox } from '../../../../../components/Checkbox/Checkbox';
import { MultiSelect } from '../../../../../components/Dropdown/MultiSelect';
import DropdownFlexContainer from './DropdownFlexContainer';

const Container = styled.div({ paddingRight: '10px' });

interface Props {
    filter: { supplier?: number[] };
    setFilter: (filter: any) => void;
    store: { suppliers: Supplier[]; load(): Promise<void> };
}

export const FilterSupplier = (props: Props) => {
    const name = 'supplier';

    const handleOnChange = value => {
        event?.preventDefault();
        props.setFilter({
            ...props.filter,
            [name]: [...new Set<string>(value?.flatMap(id => id.value))]
        });
    };

    const options = props.store.suppliers.map(v => ({
        value: v.id,
        label: (
            <DropdownFlexContainer>
                <Checkbox onChange={() => handleOnChange} checked={props.filter[name]?.includes(v.id) || false} />
                <span> {v.name}</span>
            </DropdownFlexContainer>
        )
    }));

    const selectAll = [
        {
            value: props.store.suppliers?.map(suppliers => suppliers.id),
            label: ' Välj alla'
        },
        ...options
    ];

    return (
        <Container>
            <MultiSelect
                isMulti={true}
                isClearable
                value={props.filter[name]?.map(id => ({
                    value: id,
                    label: props.store.suppliers?.find(({ id: supplier_id }) => supplier_id === +id)?.name
                }))}
                onChange={handleOnChange}
                name={name}
                label={L(name)}
                options={selectAll}
            />
        </Container>
    );
};
